// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + "webfontloader" + "." + "8a09f270" + ".js";
};